import { createContext, useContext } from 'react';

export const DragonEasterEggContext = createContext(null);

export const useDragonEasterEgg = () => {
    const context = useContext(DragonEasterEggContext);
    if (!context) {
        throw new Error('useDragonEasterEgg must be used within DragonEasterEggProvider');
    }
    return context;
};
